import script from "./goRinSyo0006.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0006.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0006.vue?vue&type=style&index=0&id=1bae2250&lang=scss"

const __exports__ = script;

export default __exports__